export const frontEndDateFormat = 'dd-mm-yyyy'
